import * as date from '@/utils/date'
export const page = {
    data: () => ({
        // list
        operatingStatusList: [],
		wayBillStatusList:[
			{key:0, value:'待走货'},{key:1, value:'待提取'},{key:2,value:'待签收'}, {key:3,value:'已签收'}, {key: 4, value: '已退走'}, {key: 5, value: '已作废'}
		],
        advanceSubjectlist: [],
        batteryList: [],
        goodsTypeList: [],
        // 附加
        spId: localStorage.getItem('savebranch'),
        Servicestafflist: [],
		salesMan: null,
        spBalance: '', // 余额
        creditLimit: '', // 信用额度
        creditLimitDays: '', // 信用天数
        creditLimitMax: '', // max
        creditLimitMin: '', // min
        creditLimitFreightMultiplier: '', // 乘
        waybillNos: '',
        tenantinfo: JSON.parse(localStorage.getItem('tenantinfo')),
        branchlist: JSON.parse(localStorage.getItem('branchlist')),
        mployeelist: JSON.parse(localStorage.getItem('mployeelist')),
        datetimerange: [date.formatDate(new Date(new Date() - 1000 * 3600 * 24 * 10), 'yyyy-MM-dd hh:mm:ss'), date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')],
    }),
    watch: {
        spId(newVal) {
            this.getbinfo(newVal)
        },
    },
    mounted() {
        this.getoperatingStatus()
        this.getAdvanceSubject()
        this.getbattery()
        this.getgoodsType()
        this.getbinfo()
    },
    methods: {
        // 操作状态字典
        async getoperatingStatus() {
            this.operatingStatusList = await this.$api.appdict('operatingStatus')
			this.operatingStatusList.forEach((item)=>{
				if(item.value == '退回'){
					item.value = ''
				}
			})
        },
        // 科目字典
        async getAdvanceSubject() {
            this.advanceSubjectlist = await this.$api.appdict('advanceSubject')
        },
		// 电池字典
		async getbattery() {
			this.batteryList = await this.$api.appdict('battery')
		},
		// 货物类型字典
		async getgoodsType() {
			this.goodsTypeList = await this.$api.appdict('goodsType')
		},
        // 更换服务商拉取余额和跟进人信息
        async getbinfo(newVal) {
            if (newVal) localStorage.setItem('savebranch', newVal)
            this.spId = localStorage.getItem('savebranch')
            this.Servicestafflist = []
            this.Servicestafflist = await this.$api.getServicestaff(this.spId)
			this.salesMan = await this.$api.getProviderSalesMan(localStorage.getItem('tenantId'), this.spId)
            this.spBalance = ''
            this.creditLimit = ''
            this.creditLimitDays = ''
            this.creditLimitMax = '' // max
            this.creditLimitMin  = '' // min
            this.creditLimitFreightMultiplier = '' // 乘
            const tenantinfo = await this.$api.gettenantinfo(this.spId)
            let tenantId = tenantinfo.tenantType == 2 ? localStorage.getItem('tenantId') : this.spId // 2为自建附属单位
            let branchCode = tenantinfo.tenantType == 2 ? this.spId : localStorage.getItem('tenantId')
            let branch = await this.$api.getspbalance(tenantId, branchCode)
            this.spBalance = tenantinfo.tenantType == 2 ? branch.spBalance : branch.balance
            this.creditLimit = branch.creditLimit
            this.creditLimitDays = branch.creditLimitDays
            this.creditLimitMax = branch.creditLimitMax
            this.creditLimitMin  = branch.creditLimitMin
            this.creditLimitFreightMultiplier = branch.creditLimitFreightMultiplier
        },
        // 重置
        resetForm() {
            this.waybillNos = ''
            this.datetimerange = [date.formatDate(new Date(new Date() - 1000 * 3600 * 24 * 10), 'yyyy-MM-dd hh:mm:ss'), date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')]
            if (this.getReset) {
                this.getReset()
            }
        },
        // 查询表格
        submitForm() {
            this.$refs[this.ref].submitForm()
        },
        // 复制
        copyclick() {
            this.$refs[this.ref].copyclick()
        },
        // 展开
        rowClickExpand(row) {
            this.$refs[this.ref].toggleRowExpansion(row)
        },
        // 导出
        handleDownload() {
            this.$refs[this.ref].handleDownload()
        },
        // 打开im运单对话
        cellclickwayBillNo(row) { //单击单号
            this.$wechatwayBill(row)
        },
        // 打开im单位对话
        cellclickwechatbranch(spId) {
            let branch = this.branchlist.find(item => item.branchCode == spId)
            this.$wechatbranch(branch)
        },
        // ---------------utils-------------------
        // 取单位
        crrbranch(branchcode) {
            let crr = this.branchlist.find(branch => (branchcode == branch.branchCode))
            return crr ? crr : {}
        },
        // 取人员
        crruser(userCode) {
            let crr = this.mployeelist.filter(user => (userCode == user.userCode) || (userCode == user.telNo))
            return crr.length>0 ? crr[0] : {userName:''}
        },
        // 时间格式化
        getDatetime(datetime) {
            let date = new Date()
            let dataStr = date.getFullYear() + '-' + (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) + '-' + (date.getDate() > 9 ? date.getDate() : '0' + date.getDate())
            if (datetime.substring(0, 10) == dataStr) {
                return datetime.substring(11, 19) // 同一天
            } else if (datetime.substring(0, 4) == dataStr.substring(0, 4)) {
                return datetime.substring(5, 19) // 同一月
            } else {
                return datetime.substring(0, 19) // 同一年
            }
        },
        // 判断整数的二进制的第几位是否开关
        numtotitflog(num, i) {
            //  如7的四位二进制为0111（ 0111 = 0+4+2+1不考虑正负符号位）
            // 1左位移2位为0100（低位方向角标0起始的第2位为1，其他为0）
            // &（与）位算符操作，0111&0100,每一位分别对应判断同时为1可计一个值，结果只有0和1，如果值为1，说明num的二进制（0111）的第2位（低位方向角标0起始）是开（开/1,关/0）
            return (num & (1 << i)) != 0
        },
        // 二进制指定位取反
        getnumtotitflog(mun, i) {
            if (!this.numtotitflog(mun, i)) {
                return mun | (1 << i)
            } else {
                return mun & ~(1 << i)
            }
        },
    },
}